import React, { useState, useEffect, useRef, useId, useContext } from 'react';
import _ from 'lodash';
import { bool, func, string } from 'prop-types';
import {
  APP_URL,
  GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_APP_SUCCESS,
  GTM_TEXT_APP_DOWNLOAD_LINK_SUCCESS,
  INTELLIMIZE_TEXT_APP_DOWNLOAD_LINK_SUCCESS
} from '../../constants/defaults';
import AppDownloadForm from '../common/AppPromoSuccessModal';
import { sendAppPromoContact } from '../../services/Api/Coupon/CouponService';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { AuthContext } from '../../Contexts';
import TextMaskCustom from '../static/TextMaskCustom';

const SocialApps = ({
  isFromHome,
  isFromDrugpage,
  isFromDiscountPage,
  triggerGTMEvents,
  isApps,
  labelText,
  type,
  isLandingPages,
  buttonText,
  isNumberSendLandingPage,
  isFromDrugClassesPage = false,
  isFromCouponPage = false,
  focusClass = 'themeFocus'
}) => {
  const [inputValue, setInputValue] = useState('');
  const [invalidInput, setInvalidInput] = useState(false);
  const [contactSent, setcontactSent] = useState(false);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const id = useId();
  const { t } = useTranslation();
  const mobileInput = useRef();
  const invalidChars = ['-', '+', 'e', '.'];

  useEffect(() => {
    if (!isApps) {
      document.body.style.overflow = contactSent ? 'hidden' : '';
    } else {
      setTimeout(() => {
        setcontactSent(false);
      }, 2000);
    }
  }, [contactSent]);

  const updateInput = (event = { target: { value: '' } }) => {
    const { value } = event.target;
    if (!value) setInputValue(value);
    if (invalidChars.indexOf(value) !== -1) {
      return;
    }
    setInputValue(value);
    if (
      event.target.value.length !== 14 &&
      !invalidChars.includes(event.target.value)
    ) {
      return;
    }

    setInputValue(value);
    setInvalidInput(false);
  };

  const validateInput = () => {
    if (inputValue.length !== 14) {
      setInvalidInput(true);
      return false;
    }
    return true;
  };

  const handleKeydownEvent = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      const isInputValid = validateInput();
      if (isInputValid) postContactAPI();
      return;
    }
  };
  const sendGTMTextSuccessEvent = () => {
    _.triggerGTMVirtualPageViewEvent({
      event: GTM_TEXT_APP_DOWNLOAD_LINK_SUCCESS,
      formId: 'mobile-app',
      phoneNumber: inputValue,
      clickText: 'Send',
      location: labelText === 'Phone number' ? 'footer' : 'body'
    });
  };
  const postContactAPI = async () => {
    let textnumber = inputValue.replace(/\D/g, '');
    try {
      let downloadAppResponse = await sendAppPromoContact(
        textnumber.trim(),
        isLoggedIn
      );
      if (downloadAppResponse && downloadAppResponse.data.Result) {
        setcontactSent(true);
        if (type === 'physicalCard')
          triggerGTMEvents(GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_APP_SUCCESS);
        if (type === 'mobileApps') sendGTMTextSuccessEvent();
        if (isFromCouponPage)
          _.sendIntellimizeEvent(INTELLIMIZE_TEXT_APP_DOWNLOAD_LINK_SUCCESS);
      }
    } catch (err) {
      console.log(err);
    } finally {
      mobileInput.current.blur();
      setInputValue('');
      setInvalidInput(false);
    }
  };

  const handleSubmit = async (event = { preventDefault() {} }) => {
    event.preventDefault();
    if (validateInput()) postContactAPI();
  };

  const clearSearchValue = event => {
    event.stopPropagation();
    event.preventDefault();
    setInputValue('');
    mobileInput.current.focus();
  };
  return (
    <div className={`appSection ${!isFromHome && 'drugpage-section'}`}>
      <div className={`${isLandingPages ? 'homeAppSection' : 'mobileAppInfo'}`}>
        {isFromHome && (
          <div className="appInfoLeft">
            <LazyLoadImage
              className="desktop-only"
              alt={t('Singlecare Mobile App')}
              src="/content/images/homepagev2/pharmacy-list.png"
              width="140px"
              height="296px"
            />
            <LazyLoadImage
              className="desktop-only"
              alt={t('Singlecare Mobile App')}
              src="/content/images/homepagev2/card-page.png"
              width="140px"
              height="296px"
            />
          </div>
        )}

        {!isFromHome && !isApps && (
          <div className="appInfoLeftDrug">
            <LazyLoadImage
              src="/content/images/pharmacy/drugapp.png"
              className="left-img desktop-only"
              alt={t('Singlecare Mobile App')}
            />
          </div>
        )}

        <div className="appInfoRight">
          {!isApps && (
            <h2>
              {type === 'physicalCard'
                ? t(
                    'Did you know that you can also use our free SingleCare app?'
                  )
                : 'Keep coupons handy with the free SingleCare app'}
            </h2>
          )}
          {isFromHome && (
            <div className="rating-block desktop-only">
              <LazyLoadImage
                src="/content/images/icons/ratingstars.png"
                alt="ratings stars"
                className="ratingstars"
              />
              <span className="rating-text">4.5-star average ratings</span>
            </div>
          )}

          <div className="desktop-only">
            <div className="mobileAppDownloadLink ">
              {!isFromDrugpage && !isApps && (
                <ul className="appLinks">
                  <li>
                    <a
                      href={
                        isFromHome && !isFromDiscountPage
                          ? APP_URL.HOME_IOS_LINK
                          : isFromDrugpage
                          ? APP_URL.DRUG_IOS_LINK
                          : APP_URL.OTHER_IOS_LINK
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueFocus dialogComponent"
                    >
                      <LazyLoadImage
                        src="/content/images/homepagev2/app-store-badge.png"
                        alt={t('App Store')}
                        className="spanishHide blueFocus"
                      />
                      <LazyLoadImage
                        src="/content/images/homepagev2/app-store-badge-spanish.png"
                        alt={t('App Store')}
                        className="spanishMapShow"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        isFromHome && !isFromDiscountPage
                          ? APP_URL.HOME_ANDROID_LINK
                          : isFromDrugpage
                          ? APP_URL.DRUG_ANDROID_LINK
                          : APP_URL.OTHER_ANDROID_LINK
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueFocus dialogComponent"
                    >
                      <LazyLoadImage
                        src="/content/images/homepagev2/google-play-badge.png"
                        alt={t('Google play')}
                        className="spanishHide"
                      />
                      <LazyLoadImage
                        src="/content/images/homepagev2/google-play-badge-spanish.png"
                        alt={t('Google play')}
                        className="spanishMapShow blueFocus"
                      />
                    </a>
                  </li>
                </ul>
              )}

              <div className="app-mobile-link desktop-only">
                <div
                  className="appReceiveLink"
                  id={`mobile-download-link${type}${id}`}
                >
                  <div>
                    {labelText
                      ? labelText
                      : type === 'physicalCard'
                      ? t('Enter your phone number to receive a download link')
                      : 'Enter mobile number to receive a download link'}
                  </div>
                </div>
                <form autoComplete="on">
                  <div className="form-control app-link-form">
                    <div className="halfwidth">
                      <TextMaskCustom
                        placeholder={'(555) 555-5555'}
                        autoComplete="tel-national"
                        value={inputValue}
                        ref={mobileInput}
                        onChange={updateInput}
                        onBlur={validateInput}
                        onKeyDown={handleKeydownEvent}
                        aria-labelledby={`mobile-download-link${type}${id}`}
                        aria-required="true"
                        className={`${
                          invalidInput ? 'invalid ' : ''
                        } ${focusClass} dialogComponent`}
                        aria-invalid={invalidInput ? 'true' : 'false'}
                        aria-describedby={`"invalidInputError${type}${id}`}
                        inputMode="numeric"
                      />
                      {!_.isEmpty(inputValue.trim()) && (
                        <button
                          className="crossbutton blueFocus dialogComponent"
                          onClick={clearSearchValue}
                        >
                          <img
                            src="/content/images/icons/search-close-x-icon.svg"
                            alt="cross icon"
                          />
                        </button>
                      )}
                      {invalidInput && (
                        <>
                          {isApps && (
                            <img
                              className="errorImg"
                              src="/content/images/icons/error.svg"
                              alt=""
                            />
                          )}

                          {isNumberSendLandingPage ? (
                            <span className="label-error" role="alert">
                              Error: {t('Phone number error')}
                            </span>
                          ) : (
                            <span
                              id={`"invalidInputError${type}${id}`}
                              className="label-error"
                              role="alert"
                            >
                              Error: {t('Phone number error')}
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    <button
                      className={`pink button submitAction dialogComponent ${
                        inputValue?.length !== 14 && 'activeButtonClass'
                      } ${contactSent && 'sentAction'} ${focusClass}`}
                      onClick={handleSubmit}
                      disabled={
                        isFromDrugClassesPage &&
                        !contactSent &&
                        inputValue?.length !== 14
                      }
                      aria-live="polite"
                    >
                      {!isApps && (
                        <React.Fragment>Text me the app</React.Fragment>
                      )}
                      {isApps && (
                        <React.Fragment>
                          {!contactSent && <span>{t(buttonText)}</span>}
                          {contactSent && <span>{t('Sent!')}</span>}
                        </React.Fragment>
                      )}
                    </button>
                    {isFromDrugpage && contactSent && !isApps && (
                      <AppDownloadForm
                        hideAppConfirmModal={() => {
                          setInvalidInput(false);
                          setcontactSent(false);
                        }}
                      />
                    )}
                  </div>
                </form>
              </div>
              {isFromDrugpage && !isApps && (
                <ul className="appLinks">
                  <li>
                    <a
                      href={
                        isFromHome && !isFromDiscountPage
                          ? APP_URL.HOME_IOS_LINK
                          : isFromDrugpage
                          ? APP_URL.DRUG_IOS_LINK
                          : APP_URL.OTHER_IOS_LINK
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueFocus dialogComponent"
                    >
                      <LazyLoadImage
                        src="/content/images/homepagev2/app-store-badge.png"
                        alt={t('App Store')}
                        className="spanishHide blueFocus"
                      />
                      <LazyLoadImage
                        src="/content/images/homepagev2/app-store-badge-spanish.png"
                        alt={t('App Store')}
                        className="spanishMapShow"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        isFromHome && !isFromDiscountPage
                          ? APP_URL.HOME_ANDROID_LINK
                          : isFromDrugpage
                          ? APP_URL.DRUG_ANDROID_LINK
                          : APP_URL.OTHER_ANDROID_LINK
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueFocus dialogComponent"
                    >
                      <LazyLoadImage
                        src="/content/images/homepagev2/google-play-badge.png"
                        alt={t('Google play')}
                        className="spanishHide"
                      />
                      <LazyLoadImage
                        src="/content/images/homepagev2/google-play-badge-spanish.png"
                        alt={t('Google play')}
                        className="spanishMapShow blueFocus"
                      />
                    </a>
                  </li>
                </ul>
              )}
            </div>
          </div>
          {!isFromDrugpage && contactSent && !isApps && (
            <AppDownloadForm
              hideAppConfirmModal={() => {
                setInvalidInput(false);
                setcontactSent(false);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

SocialApps.propTypes = {
  isFromHome: bool,
  isFromDrugpage: bool,
  isFromDiscountPage: bool,
  triggerGTMEvents: func,
  type: string,
  buttonText: string
};

SocialApps.defaultProps = {
  isFromHome: false,
  isFromDrugpage: false,
  isFromDiscountPage: false,
  triggerGTMEvents: () => {},
  type: '',
  buttonText: 'Send'
};

export default SocialApps;
